import React, { useMemo } from 'react';

import { BasketItem } from 'store/basket/basketAPI';
import { selectBasketExams } from 'store/basket/basketSlice';
import { useAppSelector } from 'store';

import { MainContainer, PageContainer } from '@britishcouncil/react-solas-ors3';

import { BasketButtons, ExamsList, Links, TotalFee } from './components';

export const BasketPreview = () => {
  const exams = useAppSelector(selectBasketExams);

  const totalFee = useMemo(() => {
    const currency = exams[0]?.currency;
    const reduceFees = (total: number, exam: BasketItem) => {
      return total + exam.fee;
    };
    return `${exams.reduce(reduceFees, 0).toFixed(2)} ${currency ?? ''}`;
  }, [exams]);

  return (
    <>
      <MainContainer>
        <h1>Exam basket</h1>
      </MainContainer>
      <PageContainer>
        <h2>You have {exams.length} exams in your basket</h2>
        {exams.length > 0 && (
          <>
            <ExamsList exams={exams} />
            <TotalFee fee={totalFee} />
          </>
        )}
        <BasketButtons showRegisterBtn={exams.length > 0} />
        <Links />
      </PageContainer>
    </>
  );
};
